// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  partyId: __t.u64().primaryKey().name("party_id"),
  gameId: __t.u64().name("game_id"),
  leader: __t.identity(),
  members: __t.string(),
  queuedAt: __t.timestamp().name("queued_at"),
});
